import { AddEditAlertParameterDto } from './add-edit-alert-parameter-dto';

export class AddEditOwnerAlertParameterDto extends AddEditAlertParameterDto {
    customerID: string;
    communityID: number;
}
